import { render, staticRenderFns } from "./gantt-message.vue?vue&type=template&id=eab01bd4&scoped=true"
import script from "./gantt-message.vue?vue&type=script&lang=js"
export * from "./gantt-message.vue?vue&type=script&lang=js"
import style0 from "./gantt-message.vue?vue&type=style&index=0&id=eab01bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab01bd4",
  null
  
)

export default component.exports